<template>
  <ReportLayoutModerno
    id="conferenceList"
    :prefecture="prefecture"
    :period="convertDate(filter.startDate) + ' até ' + convertDate(filter.endDate)"
    :showHeader="false"
  >
    <!-- Secretariat Data Blocks -->
    <div 
      v-for="(d, i) in data.supplies" 
      :key="i"
      :class="['mb-10 shadow-sm border border-slate-200 rounded-xl overflow-hidden', (i > 0 && d.sec_name !== data.supplies[i - 1].sec_name) ? 'page-break' : '']"
    >
      <!-- CABEÇALHO COMPLETO DO SETOR -->
      <header v-if="i === 0 || d.sec_name !== data.supplies[i - 1].sec_name" class="flex flex-col items-center justify-center mb-10 pb-8 border-b border-slate-100 text-center">
        <div class="w-full text-center mb-6">
           <span class="text-[10px] font-black text-slate-400 uppercase tracking-[0.3em]">{{ $store.getters.getAppName }}</span>
        </div>
        
        <img
          v-if="prefecture"
          :src="prefecture.prefecture_logo ? 'https://api.sigfrotagov.com.br/uploads/' + prefecture.prefecture_logo : require('@/assets/no-image.jpg')"
          :alt="prefecture.social_name || ''"
          class="h-24 object-contain mb-6 mx-auto"
        />
        
        <h1 v-if="prefecture" class="text-2xl font-black text-slate-800 uppercase tracking-tight mb-2 text-center">
          {{ prefecture.prefecture_social_name || '' }}
        </h1>
        
        <div class="flex flex-col items-center gap-1 text-center">
          <h4 class="text-xs font-semibold text-slate-400 uppercase tracking-wider">
            Período: {{ convertDate(filter.startDate) + ' até ' + convertDate(filter.endDate) }}
          </h4>
          <div class="mt-2">
             <h3 class="text-sm font-bold text-slate-600">
               Fornecedor: <span class="text-orange-600 uppercase font-black text-orange">{{ provider && provider.provider_name ? provider.provider_name : '' }}</span>
             </h3>
          </div>
          <div class="mt-2">
             <h3 class="text-sm font-black text-slate-800 uppercase tracking-wide">
               Relatório Geral - Setor: <span class="text-orange-600 text-orange">{{ d.sec_name }}</span>
             </h3>
          </div>
        </div>
      </header>
      <!-- CABEÇALHO DO SETOR -->
      <div class="px-8 py-4 flex items-center justify-between" style="background-color: #313131;">
        <div class="flex flex-col">
          <span class="text-[9px] font-black text-slate-400 uppercase tracking-widest mb-0.5">SECRETARIA / SETOR</span>
          <span class="text-xs font-bold text-white uppercase tracking-wider">{{ d.sec_name }}</span>
        </div>
        <v-icon color="orange" size="24">mdi-office-building-marker</v-icon>
      </div>

      <!-- TABELA DE VEÍCULOS -->
      <div class="overflow-x-auto">
        <table class="w-full text-left border-collapse">
          <thead>
            <tr class="bg-slate-50 border-b border-slate-200">
              <th class="px-6 py-3 text-[9px] font-black text-slate-500 uppercase tracking-widest">Ficha Contábil</th>
              <th class="px-6 py-3 text-[9px] font-black text-slate-500 uppercase tracking-widest">Veículo / Modelo</th>
              <th class="px-6 py-3 text-[9px] font-black text-slate-500 uppercase tracking-widest w-32">Placa</th>
              <th class="px-6 py-3 text-[9px] font-black text-slate-500 uppercase tracking-widest">Combustível</th>
              <th class="px-6 py-3 text-[9px] font-black text-slate-500 uppercase tracking-widest text-center">Cupons</th>
              <th class="px-6 py-3 text-[9px] font-black text-slate-500 uppercase tracking-widest text-right w-32">Litros</th>
              <th class="px-6 py-3 text-[9px] font-black text-slate-500 uppercase tracking-widest text-right w-32">Preço Licitado</th>
              <th class="px-6 py-3 text-[9px] font-black text-slate-500 uppercase tracking-widest text-right w-32">Total</th>
            </tr>
          </thead>
          <tbody>
            <tr class="hover:bg-slate-50 transition-colors border-b border-slate-100 last:border-0">
              <td class="px-6 py-4 text-[10px] font-bold text-slate-400 uppercase italic">{{ d.subsec_desc ? d.subsec_desc : "---" }}</td>
              <td class="px-6 py-4">
                <div class="flex flex-col">
                  <span class="text-[11px] font-black text-slate-700 uppercase leading-tight">{{ d.brand_desc }}</span>
                  <span class="text-[10px] text-slate-400 font-bold uppercase">{{ d.model_desc }}</span>
                </div>
              </td>
              <td class="px-6 py-4">
                <span class="bg-orange-50 text-orange-600 px-2 py-1 rounded font-black text-[11px] uppercase tracking-wider border border-orange-100 italic">
                  {{ d.vehicle_board }}
                </span>
              </td>
              <td class="px-6 py-4 text-[11px] font-black text-slate-600 uppercase">{{ d.item_description_desc }}</td>
              <td class="px-6 py-4 text-[9px] text-slate-400 font-bold max-w-xs text-center leading-relaxed font-mono">
                <div class="flex flex-wrap justify-center gap-1">
                  <span v-for="(coupon, ci) in (d.vehiclesCoupons ? d.vehiclesCoupons.split(',') : [])" :key="ci" class="bg-orange-50 text-orange-600 px-1.5 py-0.5 rounded border border-orange-100 whitespace-nowrap">
                    {{ coupon.trim() }}
                  </span>
                </div>
              </td>
              <td class="px-6 py-4 text-xs font-black text-slate-800 text-right">{{ d.totalLiters ? realMaskII(Number(d.totalLiters).toFixed(3)) : '0,000' }}</td>
              <td class="px-6 py-4 text-xs font-black text-slate-800 text-right">{{ d.supply_bidding_price ? realMaskII(Number(d.supply_bidding_price).toFixed(3)) : '0,000' }}</td>
              <td class="px-6 py-4 text-xs font-black text-slate-900 text-right font-mono italic">R$ {{ d.totalValue ? realMask(Number(d.totalValue).toFixed(2)) : '0,00' }}</td>
            </tr>
          </tbody>
          <!-- SUBTOTAL -->
          <tfoot class="bg-slate-50 border-t border-slate-200">
            <tr>
              <td colspan="5" class="px-6 py-4 text-right">
                <span class="text-[10px] font-black text-slate-400 uppercase tracking-widest">SUBTOTAL DO SETOR:</span>
              </td>
              <td class="px-6 py-4 text-sm font-black text-slate-800 text-right">{{ d.totalLiters ? realMaskII(Number(d.totalLiters).toFixed(3)) : 0 }}</td>
              <td class="px-6 py-4 text-sm font-black text-slate-800 text-right"></td>
              <td class="px-6 py-4 text-sm font-black text-emerald-600 text-right font-mono italic">R$ {{ d.totalValue ? realMask(Number(d.totalValue).toFixed(2)) : 0 }}</td>
            </tr>
          </tfoot>
        </table>
      </div>
    </div>

    <!-- RESUMO GERAL CONSOLIDADO -->
    <div class="mt-16 page-break">
       <div class="bg-[#242424] rounded-xl p-8 text-white shadow-2xl relative overflow-hidden">
          <div class="flex items-center gap-3 mb-8 border-b border-white/5 pb-6">
             <v-icon color="orange" size="20">mdi-sigma</v-icon>
             <div>
                <span class="text-[9px] font-black text-slate-500 uppercase tracking-widest block mb-0.5">FECHAMENTO CONSOLIDADO</span>
                <h2 class="text-sm font-black uppercase tracking-widest tracking-[0.2em]">RESUMO DO PERÍODO</h2>
             </div>
          </div>
          
          <table class="w-full text-left">
            <thead>
              <tr class="text-[10px] font-black uppercase tracking-widest text-slate-500">
                <th class="py-4 px-6">ITEM / COMBUSTÍVEL</th>
                <th class="py-4 px-6 text-right">VOLUME TOTAL</th>
                <th class="py-4 px-6 text-right">PREÇO LICITADO</th>
                <th class="py-4 px-6 text-right">VALOR ACUMULADO</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(res, it) in data.resume" :key="it" class="border-t border-white/5 hover:bg-white/5 transition-colors group">
                <td class="py-6 px-6">
                  <div class="flex items-center gap-3">
                    <div class="w-1.5 h-1.5 rounded-full bg-orange-500"></div>
                    <span class="text-sm font-black uppercase tracking-wide group-hover:text-orange-400 transition-colors">{{ res.item_description_desc }}</span>
                  </div>
                </td>
                <td class="py-6 px-6 text-right">
                  <span class="text-base font-black text-white tracking-widest">{{ res.totalLiters ? realMaskII(Number(res.totalLiters).toFixed(3)) : '0,000' }}</span>
                  <span class="ml-1 text-[10px] font-bold text-slate-500 uppercase">Lts</span>
                </td>
                <td class="py-6 px-6 text-right">
                  <span class="text-base font-black text-white tracking-widest">{{ res.supply_bidding_price ? realMaskII(Number(res.supply_bidding_price).toFixed(3)) : '0,000' }}</span>
                </td>
                <td class="py-6 px-6 text-right">
                  <span class="text-lg font-black text-white font-mono tracking-tight italic">R$ {{ res.totalValue ? realMask(Number(res.totalValue).toFixed(2)) : '0,00' }}</span>
                </td>
              </tr>
            </tbody>
            <tfoot>
              <tr class="border-t-2 border-orange-500 bg-white/5">
                <td class="py-12 px-8 font-black uppercase tracking-widest text-lg italic text-slate-400">TOTAL GERAL DO RELATÓRIO</td>
                <td class="py-12 px-6 text-right">
                   <div class="flex flex-col items-end">
                      <span class="text-[9px] font-black text-slate-500 uppercase tracking-widest mb-2 px-3 py-1 bg-white/5 rounded-full">VOLUME TOTAL</span>
                      <span class="text-2xl font-black text-white tracking-tighter">{{ data.finalTotals.totalFinalLiters ? realMaskII(Number(data.finalTotals.totalFinalLiters).toFixed(3)) : '0,000' }} <span class="text-xs uppercase ml-1">Litros</span></span>
                   </div>
                </td>
                <td class="py-12 px-10 text-right">
                   <div class="flex flex-col items-end">
                      <span class="text-[9px] font-black text-orange-500 uppercase tracking-widest mb-2 px-3 py-1 bg-orange-500/10 rounded-full">VALOR TOTAL FATURADO</span>
                      <span class="text-5xl font-black text-white font-mono tracking-tighter underline decoration-orange-500/40 underline-offset-[12px] decoration-4">
                         <span class="text-base font-bold text-slate-500 mr-2 italic">R$</span>
                         {{ data.finalTotals.totalFinalValuesBilling ? realMask(Number(data.finalTotals.totalFinalValuesBilling).toFixed(2)) : '0,00' }}
                      </span>
                   </div>
                </td>
              </tr>
            </tfoot>
          </table>
       </div>
    </div>
  </ReportLayoutModerno>
</template>

<script>
import helpers from "../../../mixins/helpers";
import ReportLayoutModerno from "@/components/ReportLayoutModerno.vue";

export default {
  components: { ReportLayoutModerno },
  props: ["data", "filter", "prefecture", "provider"],
  mixins: [helpers],
  methods: {
    initialize() {
      this.helpers;
    },
  },
};
</script>
<style>
</style>